export enum FlowUiMode {
  Edit = 'edit',
  Run = 'run',
  ReadOnly = 'readOnly',
}
